import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { ApolloClient, InMemoryCache } from '@apollo/client';
import { BatchHttpLink } from '@apollo/client/link/batch-http';
import { onError } from '@apollo/client/link/error';
import { v4 } from 'uuid';
import { getEnvVar } from '../utilities/getEnvs.js';
import { apiEndpoint, getHostName } from '../apiEndpoint/apiEndpoint.js';
import DefaultClient from './default-client/DefaultClient.js';
import batchKey from './batchKey.js';

// Generate a 16 character long lower case hex id compatible with the Zipkin data model
// Example: 2079f78068075eee
var generateId = function generateId() {
  return v4().replace(/-/g, '').substring(16).toLowerCase();
};
var createApolloClient = function createApolloClient(endpoint, errorHandler) {
  var errorMiddelware = onError(function (error) {
    if (errorHandler) {
      var _error$networkError;
      if ((error === null || error === void 0 ? void 0 : (_error$networkError = error.networkError) === null || _error$networkError === void 0 ? void 0 : _error$networkError.statusCode) === 401) ; else {
        errorHandler(error);
      }
    } else {
      // eslint-disable-next-line no-console
      console.log('generic errorMiddelware error: ', error);
    }
  });
  return new ApolloClient({
    link: errorMiddelware.concat(new BatchHttpLink({
      batchKey: batchKey,
      uri: endpoint,
      batchInterval: 10,
      batchMax: 30,
      credentials: 'include',
      fetch: function (_fetch) {
        function fetch(_x, _x2) {
          return _fetch.apply(this, arguments);
        }
        fetch.toString = function () {
          return _fetch.toString();
        };
        return fetch;
      }(function (uri, options) {
        var traceId = generateId();
        return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
          headers: _objectSpread2(_objectSpread2({}, options.headers), {}, {
            APPLICATION_ID: getEnvVar('APPLICATION_ID'),
            LOGTRACE_ID: traceId,
            'X-B3-TraceId': traceId,
            'X-B3-SpanId': traceId
          })
        }));
      })
    })),
    queryDeduplication: true,
    connectToDevTools: false,
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all'
      },
      mutate: {
        errorPolicy: 'all'
      }
    }
  });
};
var addGraphqlToPath = function addGraphqlToPath(path) {
  return "".concat(path, "/graphql/mypages");
};
var instances = function instances(errorHandler, customEndPoints) {
  var resolvedEndpoints = customEndPoints || [apiEndpoint(getHostName()).primary, apiEndpoint(getHostName()).failover];
  return resolvedEndpoints.map(function (path) {
    return {
      path: path,
      client: createApolloClient(addGraphqlToPath(path), errorHandler)
    };
  });
};
var client = function client(errorHandler, customEndPoints, onLogout) {
  return DefaultClient(instances(errorHandler, customEndPoints), onLogout);
};

export { client as default };
